module.exports = __webpack_public_path__ + "static/media/AvenirBlack.1ce2e24d.woff2";